import { render, staticRenderFns } from "./UploadXmlPdfOrderB2b.vue?vue&type=template&id=7bad2c2b&scoped=true&"
import script from "./UploadXmlPdfOrderB2b.vue?vue&type=script&lang=js&"
export * from "./UploadXmlPdfOrderB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad2c2b",
  null
  
)

export default component.exports